<div class="mt-6 is-flex app-loader" [class.is-hidden]="isHidden$ | async">
  <mks-loader></mks-loader>
</div>
